import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
// stores
import {CartStore} from 'src/app/core/stores/cart.store';
// services
import {RouteService} from '../../../core/services/route.service';
import {StorageService} from '../../../core/services/storage.service';
import { PaymentService } from 'src/app/core/services/payment.service';
// constants
import { STORAGE_CUSTOMER_DATA } from 'src/app/core/constants';

@Component({
  selector: 'app-checkout-btn',
  templateUrl: './checkout-btn.component.html',
  styleUrls: ['./checkout-btn.component.scss']
})
export class CheckoutBtnComponent implements OnInit {
  @Input() disabled = false;

  constructor(public cartStore: CartStore,
              private router: Router,
              private storageService: StorageService,
              private paymentService: PaymentService,
              private routeService: RouteService) {
  }

  ngOnInit() {
  }

  onClick(): void {
    if (this.routeService.getCurrentUrl() === this.routeService.getBaseUrl() + '/cart') {
      this.goToNextPage();
    } else {
      this.goToCartPage();
    }
  }

  goToCartPage(): void {
    const baseUrl = this.routeService.getBaseUrl();
    if (this.cartStore.items.length > 0) {
      this.router.navigate([baseUrl, 'cart'])
        .catch(error => console.log(error));
    }
  }

  async goToNextPage() {
    if (!this.cartStore.items.length) {
      return;
    }
    const data = await this.storageService.get(STORAGE_CUSTOMER_DATA);
    const baseUrl = this.routeService.getBaseUrl();
    if (data && data.phone) {
      this.paymentService.getCustomerByPhone(data.phone, false, false).subscribe(() => {
        this.router.navigate([baseUrl, 'payment']);
      });
    } else {
      await this.router.navigate([baseUrl, 'phone-number']);
    }
  }
}
